import RateMicroGraph from '../Elements/RateMicroGraph';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import mathHelper from '../Helpers/mathHelper';
import React from 'react';
import statusHelper from '../Helpers/statusHelper';
import stringHelper from '../Helpers/stringHelper';
import FaIcon from '../Elements/FaIcon';
// import urlHelper from '../Helpers/urlHelper';
import PlanningDetailList from '../Contents/Planning/PlanningDetail/PlanningDetailList';
import Link from '../Elements/link';
import PlanningStatusEnum from '../Enums/PlanningStatusEnum';
import DataTableActionButton from '../Elements/DataTable/DataTableActionButton';

export default class PlanningItem {
  constructor(item) {
    this.PlanningId = item.planningId;
    this.PricingId = item.pricingId;
    this.PricingDetailId = item.pricingDetailId;
    this.CreatedOn = item.createdOn;

    this.NumberOfEvalsPerCycle = item.numberOfEvalsPerCycle;
    this.OwningOfficeFeePerEval = item.owningOfficeFeePerEval;
    this.FieldworkFeePerEval = item.fieldworkFeePerEval;
    this.PricingOfficeName = item.pricingOfficeName;
    this.PricingDetailEditorCostPerEval = item.pricingDetailEditorCostPerEval;
    this.EvalFeePerEval = item.evalFeePerEval;
    this.EvalBonusPerCycle = item.evalBonusPerCycle;
    this.NumberOfPlanningDetails = item.numberOfPlanningDetails;

    this.FieldworkOfficeCurrency = item.fieldworkOfficeCurrency;
    this.OwningOfficeCurrency = item.owningOfficeCurrency;

    this.ClientName = item.clientName;
    this.ClientId = item.clientId;
    this.ClientOfficeId = item.clientOfficeId;
    this.ClientOfficeName = item.clientOfficeName;
    this.ClientIndustryCode = item.clientIndustryCode;
    this.ClientIndustry = item.clientIndustry;
    this.ClientOwner = item.clientOwner;

    this.OpportunityId = item.opportunityId;
    this.OpportunityName = item.opportunityName;
    this.OpportunityOfficeId = item.opportunityOfficeId;
    this.OpportunityOfficeName = item.opportunityOfficeName;
    this.OpportunityStatuscode = item.opportunityStatuscode;

    this.ServiceName = item.serviceName;
    this.ServiceId = item.serviceId;
    this.ServiceAge = item.serviceAge;

    this.CountryName = item.countryName;

    this.NumCyclesPerYear = item.numCyclesPerYear;

    this.NumberOfAssignmentsAll = item.numberOfAssignmentsAll;
    //this.NumberOfAssignmentsCancelledStatus=item.numberOfAssignmentsCancelledStatus;
    this.NumberOfAssignmentsSelfAssigned = item.numberOfAssignmentsSelfAssigned;
    this.NumberOfAssignmentsCompleted = item.numberOfAssignmentsCompleted;
    this.NumberOfAssignmentsFinalized = item.numberOfAssignmentsFinalized;
    this.NumberOfAssignmentsExcluded = item.numberOfAssignmentsExcluded;
    this.NumberOfAssignmentsInvoiced = item.numberOfAssignmentsInvoiced;

    this.NumberOfContractedAssignments = item.numberOfContractedAssignments;
    this.NumberOfPlannedAssignments = item.numberOfPlannedAssignments;
    this.NumberOfAssignmentsExcludedEx = item.numberOfAssignmentsExcludedEx;
    this.NumberOfAssignmentsExcludedPS = item.numberOfAssignmentsExcludedPS;
    this.NumberOfAssignmentsExcludedBC = item.numberOfAssignmentsExcludedBC;
    this.FieldworkOfficeRevenueContracted = item.fieldworkOfficeRevenueContracted;
    this.OwningOfficeRevenueContracted = item.owningOfficeRevenueContracted;

    this.TotalContractedFeeAmount = this.EvalFeePerEval * this.NumberOfContractedAssignments;
    this.TotalContractedEvaluatorFeePlusBonus = this.TotalContractedFeeAmount + this.EvalBonusPerCycle;
    this.TotalPlannedFeeAmount = this.EvalFeePerEval * this.NumberOfPlannedAssignments;
    this.TotalPlannedBonusAmount =
      (this.EvalBonusPerCycle / this.NumberOfContractedAssignments) * this.NumberOfPlannedAssignments;
    this.TotalPlannedEvaluatorFeePlusBonus = this.TotalPlannedFeeAmount + this.TotalPlannedBonusAmount;
    this.ActualEvaluatorFee = item.actualEvaluatorFee;
    this.ActualEvaluatorFeePerAssignment =
      this.ActualEvaluatorFee / (this.NumberOfAssignmentsAll - this.NumberOfAssignmentsExcludedEx);
    this.TotalContractedEvaluatorFeePerAssignmentInclBonus =
      this.EvalFeePerEval + this.EvalBonusPerCycle / this.NumberOfContractedAssignments;
    this.PercentageOfContractedEvaluatorFee = mathHelper.PercentageText(
      this.EvalFeePerEval + this.EvalBonusPerCycle / this.NumberOfContractedAssignments,
      this.FieldworkFeePerEval
    );
    this.PercentageOfActualEvaluatorFee = mathHelper.PercentageText(
      this.ActualEvaluatorFeePerAssignment,
      this.FieldworkFeePerEval
    );
    this.TotalPlannedEvaluatorFeePerAssignment =
      this.NumberOfPlannedAssignments === 0
        ? 0
        : this.EvalFeePerEval + this.TotalPlannedBonusAmount / this.NumberOfPlannedAssignments;

    this.Status = item.status;
    this.ReplacedByPricingId = item.replacedByPricingId;
    this.UpcomingChanges = item.upcomingChanges;

    this.PercentageOfAssignedAssignments = mathHelper.PercentageText(
      item.numberOfAssignmentsAll,
      this.NumberOfContractedAssignments
    );
    this.PercentageOfCompletedAssignments = mathHelper.PercentageText(
      item.numberOfAssignmentsCompleted,
      this.NumberOfContractedAssignments
    );
    this.PercentageOfFinalizedAssignments = mathHelper.PercentageText(
      item.numberOfAssignmentsFinalized,
      this.NumberOfContractedAssignments
    );
    this.PercentageOfExcludedAssignments = mathHelper.PercentageText(
      item.numberOfAssignmentsExcluded,
      this.NumberOfContractedAssignments
    );
    this.PercentageOfInvoicedAssignments = mathHelper.PercentageText(
      item.numberOfAssignmentsInvoiced,
      this.NumberOfContractedAssignments
    );
    this.PercentageOfSelfAssignedAssignments = mathHelper.PercentageText(
      item.numberOfAssignmentsSelfAssigned,
      this.NumberOfContractedAssignments
    );

    this.OwningOfficePlannedRevenue = this.NumberOfPlannedAssignments * this.OwningOfficeFeePerEval;
    this.OwningOfficeInvoicedRevenue = this.NumberOfAssignmentsInvoiced * this.OwningOfficeFeePerEval;
    this.FieldworkOfficePlannedRevenue = this.NumberOfPlannedAssignments * this.FieldworkFeePerEval;
    this.FieldworkOfficeInvoicedRevenue = this.NumberOfAssignmentsInvoiced * this.FieldworkFeePerEval;

    this.OpportunityActualStartOn = item.opportunityActualStartOn;
    this.OpportunityActualEndOn = item.opportunityActualEndOn;

    this.Selected = true;
  }

  static NameOfTheIdField() {
    return 'PlanningId';
  }
  static nameOfTheItemDetailList() {
    return 'PlanningItem';
  }

  static MoneyFields_FieldworkOffice = [
    'FieldworkFeePerEval',
    'PricingDetailEditorCostPerEval',
    'EvalFeePerEval',
    'EvalBonusPerCycle',
    'FieldworkOfficeRevenueContracted',
    'FieldworkOfficePlannedRevenue',
    'FieldworkOfficeInvoicedRevenue',
    'TotalContractedFeeAmount',
    'TotalContractedEvaluatorFeePlusBonus',
    'TotalPlannedFeeAmount',
    'TotalPlannedBonusAmount',
    'TotalPlannedEvaluatorFeePlusBonus',
    'ActualEvaluatorFee',
    'ActualEvaluatorFeePerAssignment',
    'TotalContractedEvaluatorFeePerAssignmentInclBonus',
    'TotalPlannedEvaluatorFeePerAssignment',
  ];

  static MoneyFields = [
    'FieldworkFeePerEval',
    'PricingDetailEditorCostPerEval',
    'EvalFeePerEval',
    'EvalBonusPerCycle',
    'FieldworkOfficeRevenueContracted',
    'FieldworkOfficePlannedRevenue',
    'FieldworkOfficeInvoicedRevenue',
    'TotalContractedFeeAmount',
    'TotalContractedEvaluatorFeePlusBonus',
    'TotalPlannedFeeAmount',
    'TotalPlannedBonusAmount',
    'TotalPlannedEvaluatorFeePlusBonus',
    'ActualEvaluatorFee',
    'ActualEvaluatorFeePerAssignment',
    'TotalContractedEvaluatorFeePerAssignmentInclBonus',
    'TotalPlannedEvaluatorFeePerAssignment',
  ];

  static Currency() {
    return 'FieldworkOfficeCurrency';
  }

  static CurrencySecondary() {
    return 'OwningOfficeCurrency';
  }

  static MoneyFields_OwningOffice = [
    'OwningOfficeFeePerEval',
    'OwningOfficeRevenueContracted',
    'OwningOfficePlannedRevenue',
    'OwningOfficeInvoicedRevenue',
  ];

  static MoneyFieldsSecondary = [
    'OwningOfficeFeePerEval',
    'OwningOfficeRevenueContracted',
    'OwningOfficePlannedRevenue',
    'OwningOfficeInvoicedRevenue',
  ];
  static DateFields = ['CreatedOn', 'OpportunityActualStartOn', 'OpportunityActualEndOn'];

  static BoolFields = ['Valami'];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: '-', label: 'General' },
        { name: 'PlanningId', label: 'Planning Id' },
        { name: 'ClientName', label: 'Client Name' },
        { name: 'OpportunityName', label: 'Opportunity Name' },
        { name: 'Status', label: 'Status' },
        { name: 'PricingOfficeName', label: 'FW Office' }, //pricing.officeid (az ennek megfelelő office neve)
        { name: 'ClientOwner', label: 'ClientOwner' },
        { name: 'OpportunityActualStartOn', label: 'Opportunity Start Date' },
        { name: 'OpportunityActualEndOn', label: 'Opportunity End Date' },

        { name: 'NumberOfEvalsPerCycle', label: 'Evals per Cycle' },
        { name: 'FieldworkFeePerEval', label: 'FW Fee' },
        { name: 'EvalFeePerEval', label: 'Evaluator Fee' },
        { name: 'EvalBonusPerCycle', label: 'Evaluator Bonus' },
        { name: 'PricingDetailEditorCostPerEval', label: 'Editor Fee' },
      ],
    },
    {
      tabName: 'DetailsResults',
      tabLabel: 'Details & Results',
      icon: 'fa-solid fa-circle-info',
      data: [
        { name: '-', label: 'Details & Results' },
        { name: 'NumberOfContractedAssignments', label: 'Contracted Assignments' },
        { name: 'NumberOfPlannedAssignments', label: 'Planned Assignments' },
        { name: 'NumberOfAssignmentsInvoiced', label: 'Invoiced Assignments' },

        { name: '-', label: '' },
        { name: '-message-', label: 'Evaluator Fee' },
        { name: 'TotalContractedEvaluatorFeePlusBonus', label: 'Total Contracted Evaluator Fee Plus Bonus' },
        { name: 'TotalPlannedEvaluatorFeePlusBonus', label: 'Total Planned Evaluator Fee Plus Bonus' },
        { name: 'ActualEvaluatorFee', label: 'Actual Evaluator Fee' },
        {
          name: 'TotalContractedEvaluatorFeePerAssignmentInclBonus',
          label: 'Total Contracted Evaluator Fee Per Assignment Incl Bonus',
        },
        { name: 'TotalPlannedEvaluatorFeePerAssignment', label: 'Total Planned Evaluator Fee Per Assignment' },
        { name: 'ActualEvaluatorFeePerAssignment', label: 'Actual Evaluator Fee Per Assignment' },
        { name: 'PercentageOfContractedEvaluatorFee', label: 'Contracted Evaluator Fee (%)' },
        { name: 'PercentageOfActualEvaluatorFee', label: 'Actual Evaluator Fee (%)' },

        { name: '-', label: '' },
        { name: '-message-', label: 'Owning Office' },
        { name: 'OwningOfficeRevenueContracted', label: 'Contracted Revenue' },
        { name: 'OwningOfficePlannedRevenue', label: 'Planned Revenue' },
        { name: 'FieldworkOfficeInvoicedRevenue', label: 'Invoiced Revenue' },

        { name: '-', label: '' },
        { name: '-message-', label: 'Fieldwork Office' },
        { name: 'FieldworkOfficeRevenueContracted', label: 'Contracted Revenue' },
        { name: 'FieldworkOfficePlannedRevenue', label: 'Planned Revenue' },
        { name: 'OwningOfficeInvoicedRevenue', label: 'Invoiced Revenue' },

        { name: '-', label: '' },
        { name: '-message-', label: 'Number of Assignments' },
        { name: 'NumberOfContractedAssignments', label: 'Contracted' },
        { name: 'NumberOfAssignmentsAll', label: 'Assigned' },
        { name: 'NumberOfAssignmentsCompleted', label: 'Completed' },
        { name: 'NumberOfAssignmentsFinalized', label: 'Finalized' },
        { name: 'NumberOfAssignmentsExcluded', label: 'Excluded' },
        { name: 'NumberOfAssignmentsInvoiced', label: 'Invoiced' },
        { name: 'NumberOfAssignmentsExcludedEx', label: 'Excluded Excl.' },
        { name: 'NumberOfAssignmentsExcludedPS', label: 'Excluded PS' },
        { name: 'NumberOfAssignmentsExcludedBC', label: 'Excluded BC' },
        { name: 'NumberOfAssignmentsSelfAssigned', label: 'Self Assigned' },

        { name: '-', label: '' },
        {
          name: '-message-',
          label: 'The percentages are counted according to the number of the contracted assignments.',
        },
        { name: 'PercentageOfAssignedAssignments', label: 'Assigned %' },
        { name: 'PercentageOfCompletedAssignments', label: 'Completion %' },
        { name: 'PercentageOfFinalizedAssignments', label: 'Finalization %' },
        { name: 'PercentageOfExcludedAssignments', label: 'Excluded %' },
        { name: 'PercentageOfInvoicedAssignments', label: 'Invoiced %' },
        { name: 'PercentageOfSelfAssignedAssignments', label: 'Self Assigned %' },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'PlanningId',
        orderById: 'PlanningId',
        data: 'PlanningId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 50,
      },
      { label: PlanningItem.getSelectedCellHeader, data: PlanningItem.getSelectedCellContent, minWidth: 50 },
      { label: 'Country', orderById: 'CountryName', data: 'CountryName' },
      {
        label: 'Assignments',
        orderById: 'NumberOfContractedAssignments',
        data: 'NumberOfContractedAssignments',
        className: 'text-right pr-1',
        minWidth: 50,
      },
      {
        label: 'Completed',
        orderById: 'PercentageOfCompletedAssignments',
        data: 'PercentageOfCompletedAssignments',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Finalized',
        orderById: 'PercentageOfFinalizedAssignments',
        data: 'PercentageOfFinalizedAssignments',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Excluded',
        orderById: 'PercentageOfExcludedAssignments',
        data: 'PercentageOfExcludedAssignments',
        className: 'text-center',
        minWidth: 50,
      },
      { label: 'Invoiced', orderById: 'Invoiced', data: 'Invoiced', className: 'text-center', minWidth: 50 },
      { label: 'Graph', data: PlanningItem.GetGraphCellContent },
      { label: 'Status', orderById: 'Status', data: PlanningItem.getStatusCellContent, minWidth: 50 },
      { label: ' ', data: PlanningItem.getDetailCellContent },
    ];
  }

  static getActionsContent(item) {
    return (
      <div>
        <DataTableActionButton
          onClick={{}}
          text='Edit'
          iconName='fa-solid fa-edit'
          roleKey='ClientContact_faicon_CreateEdit'
        />
      </div>
    );
  }
  static getDetailCellContent(item) {
    let linktext = `Planning Details ${item.NumberOfPlanningDetails}`;
    if (item.UpcomingChanges > 0) {
      linktext = `Pl. Details ${item.NumberOfPlanningDetails}+${item.UpcomingChanges}`;
      linktext = ` ${linktext}`;
    }
    return (
      <>
        {item.UpcomingChanges > 0 && (
          <FaIcon
            iconName='fa-solid fa-sync-alt'
            className='text-danger'
          />
        )}
        {/* {urlHelper.getIconLinkComponent(linktext,
				       "fa-solid fa-arrow-up-right-from-square",
					   "text-primary pl-1 pr-1",
					   "planning_PlanningDetailList/search",
					   "PricingId="+item.PlanningId,
					   "Open up in a new tab"
				
				
				)} */}
        <Link
          linktext={linktext}
          title='Planning - Planning Details'
          link={<PlanningDetailList pricingId={item.PlanningId} />}
          iconName='fa-solid fa-hammer'
          iconInLinktext={false}
          url={`planning_PlanningDetailList/search?ServiceId=${item.ServiceId}&PricingId=${item.PlanningId}`}
        />
      </>
    );
  }

  static GetGraphCellContent(item) {
    if (item.NumberOfPlannedAssignments <= 0) {
      return null;
    }
    const numbers = [
      //Not assigned
      item.NumberOfPlannedAssignments - item.NumberOfAssignmentsAll,
      //Assigned but not completed
      item.NumberOfAssignmentsAll - item.NumberOfAssignmentsCompleted,
      //completed but not finalized
      item.NumberOfAssignmentsCompleted - item.NumberOfAssignmentsFinalized,
      //Finalized but not invoiced
      item.NumberOfAssignmentsFinalized - item.NumberOfAssignmentsInvoiced,
      //Invoiced
      item.NumberOfAssignmentsInvoiced,
      //Excluded
      item.NumberOfAssignmentsExcluded,
    ];
    const colors = ['Grey', 'Orange', 'Yellow', 'LightGreen', 'Green', 'Red'];
    const names = ['Planned', 'Assigned', 'Completed', 'Finalized', 'Invoiced', 'Excluded'];

    return (
      <RateMicroGraph
        numbers={numbers}
        colors={colors}
        names={names}
      />
    );
  }

  static getStatusCellContent(item) {
    return (
      <span>
        {statusHelper.getStatusColorIcon(item.Status)}
        {stringHelper.convertToWords(item.Status)}
        {PlanningItem.getReplacedByContent(item)}
      </span>
    );
  }

  // A Replaced item belongs to a pricing that a newer approved pricing superseded. Say which one, and take the
  // user straight to the live planning - that is where the work continues.
  static getReplacedByContent(item) {
    if (item.Status !== PlanningStatusEnum.Replaced || !item.ReplacedByPricingId) {
      return null;
    }
    return (
      <span className='pl-1 text-muted'>
        (by{' '}
        <Link
          linktext={`Pricing #${item.ReplacedByPricingId}`}
          title='Planning - Planning Details'
          link={<PlanningDetailList pricingId={item.ReplacedByPricingId} />}
          url={`planning_PlanningDetailList/search?ServiceId=${item.ServiceId}&PricingId=${item.ReplacedByPricingId}`}
        />
        )
      </span>
    );
  }

  static clickOnSelect(item, indexOfItem) {}

  static getSelectedCellContent(item, indexOfItem) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        // onChange={()=>{
        //     let tempItemArray=[...this.state.planningItems];
        //     tempItemArray[indexOfItem].Selected=!tempItemArray[indexOfItem].Selected;
        //     this.setState({
        //         planningItems:tempItemArray,
        //         allSelected: this.isAllItemSelected(tempItemArray)
        //     });
        //     this.props.changeOfSelection();
        // }
        onChange={() => PlanningItem.clickOnSelect(item, indexOfItem)}
      />
    );
  }

  static getSelectedCellHeader() {
    return (
      <input
        type='checkbox'
        checked={PlanningItem.selectedStatus()}
        onChange={(e) => {
          PlanningItem.clickOnGlobalSelect(e.target.checked);
        }}
      />
    );
  }

  static selectedStatus() {
    //Placeholder function
  }

  static clickOnGlobalSelect(item, checked) {
    //Placeholder  function
  }
}
